export default "__VITE_ASSET__BZBqA8tV__"